<template>
    <v-snackbar
            v-model='snackbar_activate'
            :timeout="3000"
            :color="snackbar_color"
            top>
        <span class="sizeMessage"> {{ $store.state.snackbar_message }}</span>
        <v-btn
                @click="$store.commit('snackbar_activate_false')"
                color="white"
                text
        >{{$t('cerrar')}}</v-btn>
    </v-snackbar>
</template>

<script>
export default {
  name: 'snackbar',
  computed: {
    snackbar_activate: {
      get () {
        return this.$store.state.snackbar_activate
      },
      set () {
      }
    },
    snackbar_color: {
      get () {
        return this.$store.state.snackbar_color
      },
      set () {
      }
    }
  }
}
</script>

<style scoped>
    .sizeMessage{
        font-size: 130%;
    }
</style>
